const options = [{
    value: 'yl',
    label: 'Youth Large',
}, {
    value: 'yxl',
    label: 'Youth X-Large',
}, {
    value: 's',
    label: 'Adult Small',
}, {
    value: 'm',
    label: 'Medium',
}, {
    value: 'l',
    label: 'Large',
}, {
    value: 'xl',
    label: 'X-Large',
}, {
    value: '2xl',
    label: '2X-Large',
}, {
    value: '3xl',
    label: '3X-Large',
}];

const keys = {
    'yl': 'Youth Large',
    'yxl': 'Youth X-Large',
    's': 'Adult Small',
    'm': 'Medium',
    'l': 'Large',
    'xl': 'X-Large',
    '2xl': '2X-Large',
    '3xl': '3X-Large',
};

const abvKeys = {
    'yl': 'YL',
    'yxl': 'YXL',
    's': 'SM',
    'm': 'MD',
    'l': 'LG',
    'xl': 'XL',
    '2xl': '2XL',
    '3xl': '3XL',
};

const count = {
    'yl': 0,
    'yxl': 0,
    's': 0,
    'm': 0,
    'l': 0,
    'xl': 0,
    '2xl': 0,
    '3xl': 0,
};

export { options, keys, abvKeys, count }